import { CustomUseQueryOptions } from '../types';
import type { ApiInstance, MeApiResult } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

// Kind-agnostic session identity (ADR-039). Callers gate with
// options.enabled (typically: has a token); a 401 clears the token via the
// shared api hooks, so this never loops.
export const useMe = (api: ApiInstance, options?: CustomUseQueryOptions<MeApiResult>) => {
  const { queryKey, ...rest } = options || {};
  return useQuery({
    retry: false,
    ...rest,
    queryKey: [queryKey, 'Me'],
    queryFn: async ({ signal }) => {
      const { data } = await api.user.me({ signal });
      return data;
    },
  });
};
